import { NodeViewContent, NodeViewWrapper } from "@tiptap/react"

import styles from "./Title.module.scss"

export const TitleComponent = () => (
  <NodeViewWrapper className={styles.container}>
    <NodeViewContent className={styles.content} />
  </NodeViewWrapper>
)
